export const TAB_BAR_ITEM_SELECTED = "TAB_BAR_ITEM_SELECTED";

export function selectTabBarItem(view) {
    return {
        type: TAB_BAR_ITEM_SELECTED,
        payload: view
    };
}